import React, { useState } from 'react';
import ProfileField from 'components/ProfileField';
import ProfileAvatar from 'components/ProfileAvatar';
import { Container, Title, Card, CardHeader, CardBody } from './styles';
import Button from 'components/Button';
import { Typography } from '@mui/material';
import { COLOR_GRAY_70 } from 'styles/variables/colors';
import { useAuthUser } from 'features/auth/AuthUserContext';
import ProfileModal from 'components/ProfileModal';

export default function OverviewProfile() {
  const { user, profile } = useAuthUser();
  const [openProfileModal, setOpenProfileModal] = useState(false);

  return (
    <Container>
      <Title>Profile information</Title>
      <Card>
        <CardHeader>
          <ProfileAvatar src={profile.picture} size="md" margin="0 0 10px 0" />

          <Typography component="p" variant="body2">
            <b>{profile.name}</b>
          </Typography>

          <Typography component="p" variant="body2" style={{ color: COLOR_GRAY_70 }}>
            {profile.role && profile.role.role}
          </Typography>
        </CardHeader>

        <CardBody>
          <ProfileField label="E-mail" icon="email" value={user.email} marginBottom={14} />
          {profile.studyField && (
            <ProfileField
              label="Field of Study"
              icon="book"
              value={profile.studyField && profile.studyField.name}
              marginBottom={14}
            />
          )}

          {profile.institution && (
            <ProfileField
              label="Institution"
              icon="apartment"
              value={profile.institution}
              marginBottom={26}
            />
          )}

          <span
            style={{
              width: 'max-content',
              display: 'block',
            }}
          >
            <Button onClick={() => setOpenProfileModal(true)}>Update Field & Role</Button>
          </span>
          <ProfileModal
            open={openProfileModal}
            onClose={() => setOpenProfileModal(false)}
          ></ProfileModal>
        </CardBody>
      </Card>
    </Container>
  );
}
